/**
 * @author Fernando Ruano
 * @file constants.js
 * @description Parameter Constants
 */

// Generic actions
export const GET_ALL_PARAMETERS = 'Parameters/GET_ALL_PARAMETERS';
export const GET_PARAMETER_BY_ID = 'Parameters/GET_PARAMETER_BY_ID';
export const GET_PARAMETER_BY_KEY = 'Parameters/GET_PARAMETER_BY_KEY';
export const CREATE_PARAMETER = 'Parameters/CREATE_PARAMETER';
export const UPDATE_PARAMETER = 'Parameters/UPDATE_PARAMETER';
export const DELETE_PARAMETER_BY_ID = 'Parameters/DELETE_PARAMETER_BY_ID';
export const GET_MULTIPLE_PARAMETER_BY_KEY =
  'Parameters/GET_MULTIPLE_PARAMETER_BY_KEY';
